export default __webpack_public_path__ + "static/media/people.c49f3411.svg";